import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LabelRequiredDirective } from '@shared/directives/label-required.directive';
import { BrnDialogImports, BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmDialogImports } from '@spartan-ng/helm/dialog';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmInputImports } from '@spartan-ng/helm/input';

@Component({
  selector: 'app-dialog-creation-parcours',
  imports: [
    HlmInputImports,
    HlmDialogImports,
    FormsModule,
    HlmButtonImports,
    LabelRequiredDirective,
    HlmFieldImports,
    BrnDialogImports,
  ],
  templateUrl: './dialog-creation-parcours.component.html',
})
export class DialogCreationParcoursComponent {
  private readonly _dialogRef = inject<BrnDialogRef>(BrnDialogRef);
  private readonly _dialogContext = injectBrnDialogContext<{ cartographie: string; referentiel: string }>();

  readonly cartographie = this._dialogContext.cartographie;
  readonly referentiel = this._dialogContext.referentiel;

  readonly nom = signal<string>('');

  valider() {
    this._dialogRef.close(this.nom());
  }
}
